/* eslint-disable */
import { useContext, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MenuItem from '../../../Shared/Table/widgets/MenuItem';
import { ReactComponent as EditIcon } from '../../../../assets/icons/edit.svg';
import { ReactComponent as ResendIcon } from '../../../../assets/icons/resend.svg';
import { ReactComponent as RemoveIcon } from '../../../../assets/icons/remove.svg';
import { ALL_ROUTES } from '../../../../config/routes';
import {
  enqueueSnackbar,
  SNACKBAR_VARIANTS,
} from '../../../../redux_store/reducer/reducers/notificationsReducer';
import showServerError from '../../../../helpers/showError';
import { ClientContext } from 'react-fetching-library';
import { useParams } from 'react-router-dom';
import { AppRouteContext } from '../../../../contexts';

const RowAction = ({
                     setAnchorEl,
                     row,
                     setOpenRemoveDialog,
                     setRemovingUser,
                   }) => {
  const dispatch = useDispatch();
  const clientContext = useContext(ClientContext);
  const { accountUuid: paramAccountUuid } = useParams();
  const { en: { titles, notifications, errors, btn } } = useSelector((state) => state.i18n);
  const {
    user: contextUser,
    metadata: { currentAccount },
    isDistributionSponsor,
  } = useSelector((state) => state.user);
  const { setAppRoute } = useContext(AppRouteContext);

  const handleEditItemClick = (e, { uuid }) => {
    const isItChildAccount = paramAccountUuid && isDistributionSponsor;
    setAppRoute({
      path: (isItChildAccount ? ALL_ROUTES.user.editDS : ALL_ROUTES.user.edit).path,
      params: {
        currentAccountUuid: currentAccount.uuid,
        accountUuid: isItChildAccount ? paramAccountUuid : currentAccount.uuid,
        userUuid: uuid,
      },
      title: titles.editUser,
    });
  };

  const handleInvitationItemClick = async (e, { uuid }) => {
    const { payload, error, status } = await clientContext.query({
      method: 'POST',
      endpoint: `/accounts/${paramAccountUuid || currentAccount.uuid}/users/${uuid}/invitation`,
    });
    if (!error) {
      dispatch(
        enqueueSnackbar({
          message: notifications.emailInvitation,
          options: {
            variant: SNACKBAR_VARIANTS.success,
          },
        }),
      );
    } else {
      if (status === 500 && payload.errorCode === 1) {
        showServerError(
          dispatch,
          errors.tooManyInvitations,
          '',
          5000,
        );
      } else {
        const options = payload && {
          correlationUUID: payload.correlationUUID,
          userUUID: contextUser.uuid,
        };
        showServerError(dispatch, '', options);
      }
    }
  };

  const handleRemoveItemClick = (e, user) => {
    setOpenRemoveDialog(true);
    setRemovingUser(user);
  };

  const actions = useMemo(
    () => [
      {
        key: '1',
        icon: <EditIcon />,
        onActionClick: handleEditItemClick,
        children: titles.editUser,
      },
      {
        key: '2',
        icon: <ResendIcon />,
        onActionClick: handleInvitationItemClick,
        children: btn.resendInvitation,
        addDivider: true,
        showConditionFlag: 'canResendInvitation',
        showConditionValue: true,
      },
      {
        key: '3',
        icon: <RemoveIcon />,
        onActionClick: handleRemoveItemClick,
        children: titles.removeUser,
        isRemove: true,
      },
    ],
    [],
  );

  return <>{
    actions.map((props) => {
      const {
        children,
        onActionClick,
        icon,
        addDivider,
        isRemove,
        isDisabled,
        showConditionFlag,
        showConditionValue,
      } = props;
      return <MenuItem
        title={children}
        icon={icon}
        setAnchorEl={setAnchorEl}
        onClick={(e) => onActionClick(e, row.original)}
        hasTopDriver={addDivider}
        isErrorStyle={isRemove}
        isDisabled={isDisabled}
        rowUuid={row.original.uuid}
        showConditionFlag={row.original[showConditionFlag]}
        showConditionValue={showConditionValue}
      />;
    })
  }</>;
};

export default RowAction;
